import { WorkItemStatus } from '@customTypes/types';

export const interactionWorkItemsStatusFilters = [
  WorkItemStatus.Accepted,
  WorkItemStatus.ClubSetEndDate,
  WorkItemStatus.ContractOngoing,
  WorkItemStatus.ContractRequestedEndDate,
  WorkItemStatus.ContractRequestedEndDate,
  WorkItemStatus.Pending
];
